import { Component } from '@angular/core';

@Component({
    selector: 'app-dealer-info',
    imports: [],
    templateUrl: './dealer-info.component.html',
    styleUrl: './dealer-info.component.scss',
})
export class DealerInfoComponent {}
